/**
 * This enum is used for the status of the Utag Script Tag
 * It should represents different states :
 * MISSING : The script hasn't been added to the DOM
 * ADDED : The script tag is in the DOM but the onload event of the script is not yet fired
 * LOADED : The script tag is in the DOM AND the onload event has fired.
 */
export enum TagStatus {
    MISSING,
    ADDED,
    LOADED,
}
